/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable @typescript-eslint/naming-convention */
import { Get, Post, Put } from 'config/apiServiceConfig'
import axiosInstanceApiKong from 'config/apiServiceApiGateway'

export type GetReplenishmentTaskListRequestType =
  | Partial<{
      page_index: string | number
      page_size: string | number
      sort: string
      direction: string
      sku_number: string
      replenishment_task_no: string
      status: string
      location_ids: string
    }>
  | undefined

export type GetReplenishmentTaskListResponseType = {
  data: {
    id: number
    replenishment_task_no: string
    type: string
    created_at: number
    expiry_at: number
    total_sku: number
    total_quantity: number
    status: string
    location_name: string
    replenishment_schedule_no: string
    replenishment_product_category: string
    actions: string[]
    location_id: number
    staff: Nullable<{
      id: number
      full_name: string
    }>
  }[]
  pagination: {
    sort: string
    direction: string
    page_size: number
    page_index: number
    number_of_elements: number
  }
}

export type PutReplenishmentTaskRequestType = {
  id: number
  payload: {
    forkliftOperator?: string
    items?: {
      replenishmentTaskItemId: number
      productId: number
      productDetailId: number
      replQty: number
      actualQty: number
    }[]
    status?: string
  }
  meta?: Partial<{
    callback: () => void
  }>
}

export type PutReplenishmentTaskResponseType = {
  message: string
}

export type GetReplenishmentTaskItemRequestType = {
  id: number
  params?: Partial<{
    sku_or_name: string
    rack_label: string
    print_slip: boolean
    page_size: number
    page_index: number
  }>
}

export type GetReplenishmentTaskItemResponseType = {
  data: {
    id: number
    from_rack: string
    package_label: string
    expiry_date: number
    base_uom: string
    repl_qty: number
    to_rack: string
    product_name: string
    product_sku: string
    product_id: number
    product_detail_id: number
  }[]
  pagination: {
    page_size: number
    page_index: number
    number_of_elements: number
  }
}

export type GetReplenishmentTaskDetailRequestType = {
  id: number
  params?: Partial<{
    print_slip: boolean
    rack_label: string
  }>
}

export type GetReplenishmentTaskDetailResponseType = {
  data: {
    replenishment_task_activity: {
      status: string
      start_date: number
      end_date: number
      duration: string
      created_by: string
    }[]
    replenishment_task_item_detail: GetReplenishmentTaskItemResponseType['data']
    replenishment_task: GetReplenishmentTaskListResponseType['data'][number]
  }
}

export type GetPrintReplenishmentTaskRequestType = {
  id: number
}

export type GetPrintReplenishmentTaskResponseType = GetReplenishmentTaskDetailResponseType

export type GetReplenishmentTaskPartialRequestType = GetReplenishmentTaskItemRequestType

export type GetReplenishmentTaskPartialResponseType = GetReplenishmentTaskItemResponseType

export type GetStaffByRoleAndLocationRequestType = {
  locationId: number
  params?: Partial<{
    name: string
  }>
}

export type GetStaffByRoleAndLocationResponseType = {
  data: {
    id: number
    fullName: string
  }[]
}

export type GetStaffByRoleAndLocationKongResponseType = {
  data: {
    staff_id: number
    staff_full_name: string
  }[]
}

export type PutUpdateStaffReplenishmentTaskRequestType = {
  id: number
  payload: {
    staff_id: number
  }
}

export type PutUpdateStaffReplenishmentTaskResponseType = {
  message: string
}

export type ReplenishmentScheduleParamsType = {
  replenishment_no: string
  statuses: string
  sku_number: string
  location_ids: string
  'pagination.page_size': number
  'pagination.page_index': number
}

export type GetReplenishmentScheduleListParamsType =
  | Partial<ReplenishmentScheduleParamsType>
  | undefined

type ReplenishmentScheduleItemType = {
  day: string
  id: number
  schedule_no: string
  time: string
  max_sku: number
  category: string
  location_name: string
  location_id: number
  date: string
  schedule_type: string
}

export type GetReplenishmentScheduleResponseType = {
  data: ReplenishmentScheduleItemType[]
  pagination: {
    page_index: number
    direction?: string
    sort?: string
    page_size: number
    number_of_elements: number
  }
}

export type GetReplenishmentScheduleDetailWimsResponseType = {
  id: number
  days: string[]
  schedule_no: string
  end_date: string
  max_sku: number
  is_now: boolean
  unlimited: boolean
  location_name: string
  start_date: string
  location_id: number
  times: string[]
  category_id: number[]
  schedule_type: string
}

export type DeleteReplenishmentScheduleRequestType = {
  id: number
}

export type DeleteReplenishmentScheduleResponseType = {
  message: string
}

export type PostReplenishmentScheduleRequestType = {
  dayList?: string[]
  timeList?: string[]
  categoryIdList?: number[]
  scheduleType?: string
  locationId?: number
  maxSku?: number
  createdBy?: string
  startDate?: string
  endDate?: string
  unlimited?: boolean
  isNow?: boolean
}

export type CreateUpdateReplenishmentSchedulePayloadType = {
  schedule_type: string
  location_id: number
  max_sku: number
  is_now: boolean
  start_date: string
  end_date: string
  unlimited: boolean
  days: string[]
  times: string[]
  category_id: number[]
  created_by: string
}

export type PostReplenishmentScheduleResponseType = {
  message: string
}

export type PutReplenishmentScheduleRequestType = {
  id: number
  payload: {
    dayList?: string[]
    timeList?: string[]
    categoryIdList?: number[]
    scheduleType?: string
    locationId?: number
    maxSku?: number
    createdBy?: string
    startDate?: string
    endDate?: string
    unlimited?: boolean
    isNow?: boolean
  }
}

export type PutReplenishmentScheduleResponseType = {
  message: string
}

export type GetWarehouseLocationsResponseType = {
  location_id: number
  location_name: string
}[]

export type GetReplenishmentConfigParameterType = {
  location_ids?: number[]
  product_name_or_sku?: string
  page_size: number
  page_index: number
}

export type ReplenishmentConfigParamsType = {
  location_ids?: string
  product_name_or_sku?: string
  'pagination.page_size': number
  'pagination.page_index': number
}

export type ReplenishmentConfigItemType = {
  id: number
  product_id: number
  location_id: number
  location_name: string
  sku_number: string
  product_image?: string
  product_name: string
  configs: {
    storage_type_id: number
    min_qty: number
    max_qty: number
    replenish_qty: number
    active: boolean
  }[]
}

export type UpdateReplenishmentConfigRequestType = {
  location_id: number
  product_id: number
  configs: ReplenishmentConfigItemType['configs']
}

export const getReplenishmentTaskListAPI = (params: GetReplenishmentTaskListRequestType) =>
  Get<GetReplenishmentTaskListResponseType>({
    url: '/api/ims/v2/replenishment-task',
    params,
  })

export const getPrintReplenishmentTaskDetailAPI = ({ id }: GetPrintReplenishmentTaskRequestType) =>
  Get<GetPrintReplenishmentTaskResponseType>({
    url: `/api/ims/v2/replenishment-task/${id}`,
    params: { printSlip: true },
  })

export const getReplenishmentTaskDetailAPI = ({ id }: GetReplenishmentTaskDetailRequestType) =>
  Get<GetReplenishmentTaskDetailResponseType>({
    url: `/api/ims/v2/replenishment-task/${id}`,
  })

export const getReplenishmentTaskItemAPI = ({ id, params }: GetReplenishmentTaskItemRequestType) =>
  Get<GetReplenishmentTaskItemResponseType>({
    url: `/api/ims/v2/replenishment-task/${id}/item`,
    params,
  })

export const putReplenishmentTaskAPI = ({ id, payload }: PutReplenishmentTaskRequestType) =>
  Put<PutReplenishmentTaskResponseType>({
    url: `/api/ims/replenishment-task/v1/${id}`,
    data: payload,
  })

export const getReplenishmentSchedule = (params: GetReplenishmentScheduleListParamsType) =>
  axiosInstanceApiKong.Get<GetReplenishmentScheduleResponseType, true>({
    url: '/wims/internal/v1/replenishments/schedules',
    params,
  })

export const getReplenishmentScheduleDetail = (id: number) =>
  axiosInstanceApiKong.Get<GetReplenishmentScheduleDetailWimsResponseType>({
    url: `/wims/internal/v1/replenishments/schedules/${id}`,
  })

export const postReplenishmentScheduleAPI = (payload: PostReplenishmentScheduleRequestType) =>
  Post<PostReplenishmentScheduleResponseType>({
    url: `/api/ims/replenishment/v1`,
    data: payload,
  })

export const postReplenishmentScheduleWims = (data: CreateUpdateReplenishmentSchedulePayloadType) =>
  axiosInstanceApiKong.Post<{ message: string }, true>({
    url: '/wims/internal/v1/replenishments/schedules',
    data,
  })

export const putReplenishmentScheduleAPI = ({ id, payload }: PutReplenishmentScheduleRequestType) =>
  Put<PutReplenishmentScheduleResponseType>({
    url: `/api/ims/replenishment/v1/${id}`,
    data: payload,
  })

export const putReplenishmentScheduleWims = (
  scheduleId: number,
  data: CreateUpdateReplenishmentSchedulePayloadType,
) =>
  axiosInstanceApiKong.Put<{ message: string }, true>({
    url: `/wims/internal/v1/replenishments/schedules/${scheduleId}`,
    data,
  })

export const deleteReplenishmentSchedule = (scheduleId: number) =>
  axiosInstanceApiKong.Delete<
    {
      message: string
    },
    true
  >({ url: `/wims/internal/v1/replenishments/schedules/${scheduleId}` })

export const getWarehouseLocationsAPI = () =>
  Get<GetWarehouseLocationsResponseType>({
    url: `/api/locations/warehouse`,
  })

export type GetCategoryQueryParamsType = {
  'pagination.page_index': number
  'pagination.page_size': number
  'pagination.sort'?: string
  'pagination.direction'?: 'asc' | 'desc'
  'filter.active'?: boolean
  'filter.name'?: string
}

export type CategoryType = {
  name: string
  id: number
  mslod: number
  mslor: number
  msltc: number
  children?: CategoryType[]
}

export const getNewCategoriesAPI = (params: GetCategoryQueryParamsType) =>
  axiosInstanceApiKong.Get<CategoryType[]>({
    url: '/wims/internal/v1/categories',
    params,
  })

export const getStaffByRoleAndLocationAPI = ({
  locationId,
}: GetStaffByRoleAndLocationRequestType) =>
  axiosInstanceApiKong.Post<GetStaffByRoleAndLocationKongResponseType, true>({
    url: `/staff-management/internal/v1/staff/get-by-role`,
    data: {
      role_name: 'AUTH_INVENTORY_CONTROLLER',
      location_id: locationId,
    },
  })

export const putUpdateStaffReplenishmentTaskAPI = ({
  id,
  payload,
}: PutUpdateStaffReplenishmentTaskRequestType) =>
  Put<PutUpdateStaffReplenishmentTaskResponseType>({
    url: `/api/ims/v2/replenishment-task/${id}/staff`,
    data: payload,
  })

export const getReplenishmentConfig = (params: ReplenishmentConfigParamsType) =>
  axiosInstanceApiKong.Get<ReplenishmentConfigItemType[]>({
    url: '/wims/internal/v2/replenishments/configs',
    params,
  })

export const updateReplenishmentConfig = (data: UpdateReplenishmentConfigRequestType) =>
  axiosInstanceApiKong.Post<{ message: string }, true>({
    url: '/wims/internal/v2/replenishments/configs',
    data,
  })
